import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Header from "./Header";
import { Link } from "react-router-dom";

class Education extends Component {
    state = {
    
	};

    componentDidMount() {
       
    }

    hideWelcome = () => {
        
    };

    render() {
        const user = this.context.state.user;

        return (
            <Fragment>
                <Header></Header>
                <div>
				    Education
				</div>
            </Fragment>
        );
    }
}
Education.contextType = AppContext;
export default Education;



// WEBPACK FOOTER //
// ./src/components/writer/education/Education.js